define('editor/edit/layers/edit/circle',['jquery', './vectorBase'], function ($, vectorBase) {
    var viewmodel = function () {
        var self = this;

        var moduleId = self.__moduleId__;
        $.extend(self, new vectorBase());
        self.__moduleId__ = moduleId;
    };

    return viewmodel;
});

